import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, {
  Navigation,
  Pagination,
  EffectFade,
  Autoplay,
} from 'swiper'
import AnimateHeight from 'react-animate-height'
import './styles.scss'

SwiperCore.use([Navigation, Pagination, EffectFade, Autoplay])

const HeroSlider = ({
  slider: { slides, circle },
  isMD,
  isSM,
  post,
  shownews,
}) => {
  const [slideIndex, setSlideIndex] = useState(0)
  const swiperRef = useRef(null)

  const stopAutoplay = () => {
    swiperRef.current.swiper.autoplay.stop()
  }

  const startAutoplay = () => {
    swiperRef.current.swiper.autoplay.start()
  }

  const swiperOptions = {
    ref: swiperRef,
    navigation: !isMD,
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: isMD,
    autoplay: {
      delay: 10000,
    },
    pagination: { clickable: true },
    onRealIndexChange: swiper => {
      setSlideIndex(swiper.realIndex)
    },
    onInit: swiper => {
      // Pause autoplay slides on hover
      swiper.el.addEventListener('mouseenter', stopAutoplay)
      swiper.el.addEventListener('mouseleave', startAutoplay)
    },
    onDestroy: swiper => {
      // Remove unnecessary listeners from slider
      swiper.el.removeEventListener('mouseenter', stopAutoplay)
      swiper.el.removeEventListener('mouseleave', startAutoplay)
    },
  }

  let counter = 0
  if (shownews && post.title && post.image) {
    counter = 1
  }
  //console.log('slides', slides) // eslint-disable-line

  return (
    <div className="hero-slider">
      <Swiper {...swiperOptions}>
        {shownews && post.title && post.image && (
          <SwiperSlide key={0}>
            {post.permalink && (
              <a href={post.permalink} className="swiper-slide__link" />
            )}
            <div
              className="swiper-slide__background lazyload"
              data-bg={
                isSM
                  ? post.imageMobile
                    ? post.imageMobile
                    : post.image
                  : isMD
                  ? post.imageTablet
                    ? post.imageTablet
                    : post.image
                  : post.imageDesktop
                  ? post.imageDesktop
                  : post.image
              }
            />
            {isMD && (
              <div className="swiper-slide__content">
                <div className="meta"></div>
                <h1>
                  {post.title}
                  <br />
                  <strong>{post.titlebold}</strong>
                </h1>
                {post.permalink && (
                  <a
                    className="button icon"
                    href={post.permalink}
                    dangerouslySetInnerHTML={{
                      __html: post.btn + '<i class="btb bt-arrow-right"></i>',
                    }}
                  />
                )}
              </div>
            )}
          </SwiperSlide>
        )}
        {slides.map((slide, i) => (
          <SwiperSlide key={i + counter}>
            {slide.video && (
              <a className="videolink" href={slide.video.url}>
                <svg
                  className="playbtn"
                  xlmns="http://www.w3.org/2000/svg"
                  viewBox="0 0 100 100"
                  preserveAspectRatio="none"
                  style={{
                    height: `100px`,
                  }}
                >
                  <path d="M20,10 80,50 20,90 z"></path>
                </svg>
                <p>Video abspielen</p>
              </a>
            )}
            {slide.link && (
              <a href={slide.link.url} className="swiper-slide__link" />
            )}
            <div
              className="swiper-slide__background lazyload"
              data-bg={
                isSM
                  ? slide.imageMobile
                    ? slide.imageMobile
                    : slide.image
                  : isMD
                  ? slide.imageTablet
                    ? slide.imageTablet
                    : slide.image
                  : slide.imageDesktop
                  ? slide.imageDesktop
                  : slide.image
              }
            />
            {isMD && (
              <div className="swiper-slide__content">
                <div className="meta">
                  {slide.tag && (
                    <p>
                      <span className="tag">{slide.tag}</span>
                    </p>
                  )}
                </div>
                <h1>
                  {slide.title}
                  <br />
                  <strong>{slide.titleBold}</strong>
                </h1>
                {slide.smalltext && <p>{slide.smalltext}</p>}
                {slide.link && (
                  <a
                    className="button icon"
                    href={slide.link.url}
                    dangerouslySetInnerHTML={{
                      __html:
                        slide.link.title + '<i class="btb bt-arrow-right"></i>',
                    }}
                  />
                )}
              </div>
            )}
          </SwiperSlide>
        ))}

        {!isMD && (
          <div className="hero-slider__nav">
            <div className="container">
              <div className="row">
                <div className="col-12 col-lg-6">
                  <ul>
                    {shownews && post.title && post.image && (
                      <li
                        key={0}
                        onClick={() => {
                          swiperRef.current.swiper.slideTo(1)
                        }}
                      >
                        <AnimateHeight
                          className={`ctn ${0 === slideIndex ? 'active' : ''}`}
                          height={0 === slideIndex ? 'auto' : 50}
                          delay={0}
                          duration={250}
                        >
                          <div
                            style={{ height: 0 === slideIndex ? '' : 0 }}
                            className="ctn--head"
                          >
                            {post.title} - {post.titlebold}
                          </div>
                          <div className="ctn--body">
                            <div className="meta"></div>
                            <h1
                              className={
                                post.title.length + post.titlebold.length > 85
                                  ? 'shrinken'
                                  : ''
                              }
                            >
                              {post.title}
                              <br />
                              <strong>{post.titlebold}</strong>
                            </h1>
                            {post.permalink && post.btn && (
                              <a
                                className="button icon"
                                href={post.permalink}
                                target={''}
                                rel={''}
                                dangerouslySetInnerHTML={{
                                  __html:
                                    post.btn +
                                    '<i class="btb bt-arrow-right"></i>',
                                }}
                              />
                            )}
                          </div>
                        </AnimateHeight>
                      </li>
                    )}
                    {slides.map((slide, i) => (
                      <li
                        key={i + counter}
                        onClick={() => {
                          swiperRef.current.swiper.slideTo(i + counter + 1)
                        }}
                      >
                        <AnimateHeight
                          className={`ctn ${
                            i + counter === slideIndex ? 'active' : ''
                          }`}
                          height={i + counter === slideIndex ? 'auto' : 50}
                          delay={0}
                          duration={250}
                        >
                          <div
                            style={{
                              height: i + counter === slideIndex ? '' : 0,
                            }}
                            className="ctn--head"
                          >
                            {slide.title} - {slide.titleBold}
                          </div>
                          <div className="ctn--body">
                            <div className="meta">
                              {slide.tag && (
                                <p>
                                  <span className="tag">{slide.tag}</span>
                                </p>
                              )}
                            </div>
                            <h1
                              className={
                                slide.title.length + slide.titleBold.length > 85
                                  ? 'shrinken'
                                  : ''
                              }
                            >
                              {slide.title}
                              <br />
                              <strong>{slide.titleBold}</strong>
                            </h1>
                            {slide.smalltext && <p>{slide.smalltext}</p>}
                            {slide.link && (
                              <a
                                className="button icon"
                                href={slide.link.url}
                                target={slide.link.target ? '_blank' : ''}
                                rel={slide.link.target ? 'noopener' : ''}
                                dangerouslySetInnerHTML={{
                                  __html:
                                    slide.link.title +
                                    '<i class="btb bt-arrow-right"></i>',
                                }}
                              />
                            )}
                          </div>
                        </AnimateHeight>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
      </Swiper>
      {circle.text && (
        <div className="slider--circle">
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="crcl">
                  <p dangerouslySetInnerHTML={{ __html: circle.text }} />
                  <a
                    href={circle.link.url}
                    target={circle.link.target}
                    rel={circle.link.target ? 'noopener' : ''}
                  >
                    <strong>{circle.link.title}</strong>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

HeroSlider.propTypes = {
  isMD: PropTypes.bool,
  isSM: PropTypes.bool,
  slider: PropTypes.object.isRequired,
  post: PropTypes.object.isRequired,
  shownews: PropTypes.bool,
}

export default HeroSlider
